import { createFileRoute } from '@tanstack/react-router'

import PagePlaygroundCharacter from '../pages/PagePlaygroundCharacter'

export const Route = createFileRoute('/playground/character')({
  component: PagePlaygroundCharacter
})
